
/* INVENTORY */
export const GET_INVENTORY_LISTING = "GET_INVENTORY_LISTING";
export const GET_INVENTORY_LISTING_SUCCESS = "GET_INVENTORY_LISTING_SUCCESS";
export const GET_INVENTORY_LISTING_FAIL = "GET_INVENTORY_LISTING_FAIL";

export const GET_INVENTORY_DETAILS = "GET_INVENTORY_DETAILS";
export const GET_INVENTORY_DETAILS_SUCCESS = "GET_INVENTORY_DETAILS_SUCCESS";
export const GET_INVENTORY_DETAILS_FAIL = "GET_INVENTORY_DETAILS_FAIL";

export const ADD_INVENTORY = "ADD_INVENTORY";
export const ADD_INVENTORY_SUCCESS = "ADD_INVENTORY_SUCCESS";
export const ADD_INVENTORY_FAIL = "ADD_INVENTORY_FAIL";

export const UPDATE_INVENTORY = "UPDATE_INVENTORY";
export const UPDATE_INVENTORY_SUCCESS = "UPDATE_INVENTORY_SUCCESS";
export const UPDATE_INVENTORY_FAIL = "UPDATE_INVENTORY_FAIL";

export const UPDATE_LOWTHRESHOLD = "UPDATE_LOWTHRESHOLD";
export const UPDATE_LOWTHRESHOLD_SUCCESS = "UPDATE_LOWTHRESHOLD_SUCCESS";
export const UPDATE_LOWTHRESHOLD_FAIL = "UPDATE_LOWTHRESHOLD_FAIL";

export const EXPORT_INVENTORY = "EXPORT_INVENTORY";
export const EXPORT_INVENTORY_SUCCESS = "EXPORT_INVENTORY_SUCCESS";
export const EXPORT_INVENTORY_FAIL = "EXPORT_INVENTORY_FAIL";


export const EXPORT_INVENTORY_LOG = "EXPORT_INVENTORY_LOG";
export const EXPORT_INVENTORY_LOG_SUCCESS = "EXPORT_INVENTORY_LOG_SUCCESS";
export const EXPORT_INVENTORY_LOG_FAIL = "EXPORT_INVENTORY_LOG_FAIL";

export const RESET_INVENTORY_STATE = 'RESET_INVENTORY_STATE';
export const RESET_INVENTORY_ATTACHMENT_STATE = 'RESET_INVENTORY_ATTACHMENT_STATE';